<template>
	<div class="mt-4">
		<label class="g-label"
			>{{ field.label | capitalize }}
			<label class="font-bold text-danger">{{ field.required ? "*" : "" }}</label></label
		>
		<div class="flex flex-wrap flex-grow justify-start">
			<vx-input-group class="mt-2">
				<template slot="prepend">
					<div class="mr-2 vs-con-loading__container g-label--normal" :id="field.name">
						<img :src="renderIcon" class="rounded img-avatar--cover" :alt="imgTitle" :title="imgTitle" />
					</div>
				</template>
				<template slot="prepend">
					<div class="flex justify-center items-center">
						<label
							v-if="dataFile && isLabel"
							class="custom-file-upload g-label--normal text-dark"
							style="border-radius: 4px; border: 1px solid black"
							:title="$t('Crud.Delete')"
							@click="removeAvatar"
						>
							{{ $t("Crud.Delete") + " " + $t("general.Archive") }}
						</label>
						<feather-icon
							v-else-if="!dataFile && update"
							icon="Trash2Icon"
							svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
							class="append-text text-danger g-label--normal"
							:title="$t('Remove')"
							@click.prevent="removeAvatar"
						/>
						<label
							v-else
							class="custom-file-upload g-label--normal text-dark"
							style="border-radius: 4px; border: 1px solid black"
							:title="inputFileTitle"
						>
							<input type="file" :accept="inputAcceptFiles" @change="onFileChange" />
							{{ $t("UploadFiles.SelectFile") }}
						</label>
						<feather-icon
							v-if="!dataFile && update"
							icon="DownloadIcon"
							svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
							class="append-text text-success g-label--normal"
							:id="`download-${field.name}`"
							:title="$t('ManualData.DownloadFile')"
							@click.prevent="downloadFile"
						/>
					</div>
				</template>
			</vx-input-group>
		</div>
	</div>
</template>

<script>
import {uploadFileToFirebase} from "@/helpers/firebaseDB.js";
import UploadedFile from "@/models/UploadedFile.js";
import {deleteFileToFirebase} from "../../helpers/firebaseDB";

export default {
	props: {
		field: {
			Type: Object,
			default: "",
		},
		additionalInfo: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			isLabel: false,
			avatar: "",
			firebasePath: "/additional_info/",
			dataFile: null,
			fileName: "",
			payloadResource: {},
			firebaseResponse: {
				downloadURL: "",
				bucketPath: "",
			},
			imgTitle: "",
			update: false,
			urlFile: null,
			urlDecoded: {fileName: new Date().getTime() + "", fileExtension: "unknown"},
		};
	},
	computed: {
		renderIcon: {
			get() {
				return this.avatar;
			},
			set(val) {
				this.avatar = val;
			},
		},
		inputFileTitle() {
			if (this.field.type === "img") {
				return this.$t("Setting.AllowedLogo");
			}
			return this.$t("Zonification.UploadZones.SelectFileText");
		},
		btnUploadTitle() {
			if (this.field.type === "img") {
				return this.$t("Setting.UploadImage");
			}
			return this.$t("Upload");
		},
		inputAcceptFiles() {
			if (this.field.type === "img") {
				return "image/*";
			}
			return "/*";
		},
	},
	methods: {
		openLoadingButton(btnId, backgroundLoading = this.backgroundLoading) {
			this.$vs.loading({
				background: backgroundLoading,
				color: this.colorLoading,
				container: btnId,
				scale: 0.45,
			});
		},
		closeLoadingButton(btnId) {
			this.$vs.loading.close(btnId + " > .con-vs-loading");
		},
		update_avatar() {
			this.openLoadingButton("#" + this.field.name);
			uploadFileToFirebase
				.call(this, this.dataFile, this.firebasePath)
				.then((res) => {
					Object.assign(this.firebaseResponse, res);
					this.additionalInfo[this.field.name] = this.firebaseResponse.downloadURL;
					this.closeLoadingButton("#" + this.field.name);
					this.$vs.notify({
						color: "success",
						title: this.$t("UploadFiles.UploadSuccess"),
						text: this.$t("UploadFiles.UploadSuccessMessage"),
					});
					this.isLabel = true;
				})
				.catch((err) => {
					this.isLabel = false;
					this.closeLoadingButton("#" + this.field.name);
					throw new Error(err);
				});
		},
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			this.dataFile = files[0];
			this.fileName = this.dataFile.name;
			const fileNameSplitted = this.fileName.split(".");
			const fileType = Array.isArray(fileNameSplitted)
				? fileNameSplitted[fileNameSplitted.length - 1].toLowerCase()
				: "_blank";
			this.imgTitle = this.dataFile.name;
			if (this.field.type === "img") {
				this.avatar = URL.createObjectURL(files[0]);
			} else {
				try {
					this.avatar = require("@/assets/images/svg-icons/" + fileType + ".svg");
				} catch (error) {
					this.avatar = require("@/assets/images/svg-icons/unknown.svg");
				}
			}
			this.update_avatar();
		},
		removeAvatar(val) {
			if (this.field.type === "img") {
				this.avatar = require("@/assets/images/svg-icons/image.svg");
			} else {
				this.avatar = require("@/assets/images/svg-icons/file-plus.svg");
			}
			this.payloadResource.img_url = "";
			this.additionalInfo[val] = null;
			this.dataFile = null;
			this.firebasePath = "/additional_info/";
			if (this.urlDecoded.fileName && this.urlDecoded.fileExtension)
				deleteFileToFirebase(
					this.firebasePath,
					`${this.urlDecoded.fileName}.${this.urlDecoded.fileExtension}`
				).then(() => {
					this.urlDecoded = {fileName: "", fileExtension: "unknown"};
				});
		},
		async downloadFile() {
			const uploadedFile = new UploadedFile({});
			if (!this.urlFile) return;
			this.openLoadingButton(`#download-${this.field.name}`);
			await uploadedFile.downloadFile(this.urlDecoded.fileName, this.urlFile);
			this.closeLoadingButton(`#download-${this.field.name}`);
			this.$vs.notify({
				color: "success",
				title: this.$t("Notification.DOWNLOAD_FINALIZED"),
				text: `${this.$t("Reports.FileName")}`,
				time: 8000,
				fixed: false,
			});
		},
		decodeUrl(url = "") {
			const decodeUrl = decodeURIComponent(url);
			const urlSlashSplitted = decodeUrl.split("/");
			const splittedByQuestion = urlSlashSplitted[urlSlashSplitted.length - 1].split("?")[0];
			const splittedByDot = splittedByQuestion.split(".");
			if (Array.isArray(splittedByDot)) {
				if (splittedByDot.length > 2) {
					return {
						fileName: `${splittedByDot[0]}.${splittedByDot[1]}`,
						fileExtension: splittedByDot[splittedByDot.length - 1].toLowerCase(),
					};
				} else {
					return {fileName: splittedByDot[0], fileExtension: splittedByDot[1].toLowerCase()};
				}
			}
			return this.urlDecoded;
		},
	},
	created() {
		// Validar si la imagen o el archivo vienen en el additionalInfo y se asigna al avatar
		if (this.field.type === "file") {
			this.firebasePath = "/additional_info/";
			if (Object.hasOwnProperty.call(this.additionalInfo, this.field.name)) {
				this.update = true;
				this.urlFile = this.additionalInfo[this.field.name];
				Object.assign(this.urlDecoded, this.decodeUrl(this.urlFile));
				try {
					this.avatar = require(`@/assets/images/svg-icons/${this.urlDecoded.fileExtension}.svg`);
				} catch (error) {
					this.avatar = require("@/assets/images/svg-icons/file-plus.svg");
				}
				this.imgTitle = `${this.urlDecoded.fileName}.${this.urlDecoded.fileExtension}`;
			} else {
				this.avatar = require("@/assets/images/svg-icons/file-plus.svg");
			}
		} else if (this.field.type === "img") {
			this.firebasePath = "/additional_info/";
			if (Object.hasOwnProperty.call(this.additionalInfo, this.field.name)) {
				this.avatar = this.additionalInfo[this.field.name];
				this.urlFile = this.additionalInfo[this.field.name];
				this.update = true;
				Object.assign(this.urlDecoded, this.decodeUrl(this.avatar));
				this.imgTitle = `${this.urlDecoded.fileName}.${this.urlDecoded.fileExtension}`;
			} else {
				this.avatar = require("@/assets/images/svg-icons/image.svg");
			}
		} else {
			this.avatar = require("@/assets/images/svg-icons/image.svg");
		}
	},
};
</script>

<style scoped>
.img-avatar--cover {
	width: 100% !important;
	height: 45px !important;
	object-fit: cover;
}

input[type="file"] {
	display: none;
}

.custom-file-upload {
	border: 1px solid #ccc;
	display: inline-block;
	padding: 6px 12px;
	cursor: pointer;
}
</style>
